import type { Patient, Lender, Session } from "../types";

// Used when the API isn't reachable (demo mode). NOT real PHI.
export const DEMO_PATIENT: Patient = {
  id: "p_8f2a",
  firstName: "Marguerite",
  middleName: "Eloise",
  lastName: "Hollander",
  dob: "1962-03-14",
  ssnLast4: "6783",
  phone: "(301) 555-0144",
  email: "m.hollander@example.com",
  address: {
    street: "4218 Brookville Road, Apt 2B",
    city: "Chevy Chase",
    state: "MD",
    zip: "20815",
  },
  employer: "Montgomery County Public Schools",
  employmentLength: "11 years",
  annualIncome: 92000,
  monthlyHousing: 2150,
};

export const DEMO_SESSION: Session = {
  id: "s_demo",
  patientId: "p_8f2a",
  startedAt: new Date().toISOString(),
  treatmentType: "Full arch — upper",
  treatmentNotes:
    "All-on-4, upper arch. Includes extractions, immediate load, and final zirconia prosthetic at month 4.",
  requestedAmount: 38500,
};

export const LENDERS: Lender[] = [
  {
    id: "proceed",
    name: "Proceed Finance",
    tag: "Primary — high-ticket",
    portal: "https://app.proceedfinance.com",
    swatch: "#1f5f7a",
    blurb: "Best for full-arch and full mouth. Soft pull, extended terms up to 144 months.",
    tip: "Lead with Proceed for amounts ≥ $25k. Requires full SSN — get patient permission before revealing.",
    fieldKeys: [
      "fullName", "dob", "ssn",
      "addressLine", "annualIncome",
      "employer", "employmentLength",
      "monthlyHousing", "requestedAmount",
      "treatmentNotes",
    ],
  },
  {
    id: "cherry",
    name: "Cherry",
    tag: "Backup — soft pull",
    portal: "https://patient.withcherry.com/staff",
    swatch: "#2a6b6b",
    blurb: "Patient-facing flow, SMS verification. Lower max but instant decisions.",
    tip: "If Proceed declines, Cherry next. Patient receives SMS — confirm phone is correct before submitting.",
    fieldKeys: [
      "firstName", "lastName", "dob",
      "ssnLast4", "phone", "email",
      "requestedAmount",
    ],
  },
  {
    id: "sunbit",
    name: "Sunbit",
    tag: "Smaller balances",
    portal: "https://merchant.sunbit.com",
    swatch: "#3a4a6b",
    blurb: "Strong for $1k–$10k. Often approves where the others don't.",
    tip: "Use for partial-balance financing — combine with patient out-of-pocket.",
    fieldKeys: [
      "fullName", "dob", "ssnLast4",
      "phone", "annualIncome",
      "requestedAmount",
    ],
  },
];
